import React from 'react'
import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import { ArrowLeft } from 'lucide-react'
import { Button } from '../components/intake/shared/Button'
export function CheckoutCancel() {
  return (
    <div className="min-h-screen bg-[#FDFCFE] text-[#2D2A35] font-sans selection:bg-[#B5A8D4]/20 overflow-hidden">
      <div className="max-w-2xl mx-auto px-6 py-12 sm:py-20 relative z-10">
        <motion.div
          initial={{
            opacity: 0,
            y: -20,
          }}
          animate={{
            opacity: 1,
            y: 0,
          }}
          transition={{
            duration: 1,
            ease: [0.25, 0.1, 0.25, 1],
          }}
          className="mb-16 flex justify-center"
        >
          <span className="font-semibold text-xl tracking-tight niyyah-gradient">
            Niyyah
          </span>
        </motion.div>

        <div className="flex flex-col items-center justify-center min-h-[70vh] text-center space-y-16 relative">
          {/* Cancel Icon */}
          <motion.div
            initial={{
              scale: 0.8,
              opacity: 0,
            }}
            animate={{
              scale: 1,
              opacity: 1,
            }}
            transition={{
              duration: 1.2,
              ease: [0.25, 0.1, 0.25, 1],
            }}
            className="relative"
          >
            <div className="w-32 h-32 rounded-full bg-gradient-to-br from-[#B5A8C3] to-[#9B87C7] flex items-center justify-center organic-shadow">
              <motion.div
                initial={{
                  opacity: 0,
                  scale: 0.8,
                }}
                animate={{
                  opacity: 1,
                  scale: 1,
                }}
                transition={{
                  delay: 0.6,
                  duration: 0.8,
                  ease: [0.25, 0.1, 0.25, 1],
                }}
              >
                <ArrowLeft className="w-16 h-16 text-white stroke-[1.5] relative z-10" />
              </motion.div>
            </div>
          </motion.div>

          {/* Title and Subtitle */}
          <div className="space-y-6 max-w-2xl mx-auto">
            <motion.h1
              initial={{
                opacity: 0,
                y: 30,
              }}
              animate={{
                opacity: 1,
                y: 0,
              }}
              transition={{
                delay: 0.4,
                duration: 1.2,
                ease: [0.25, 0.1, 0.25, 1],
              }}
              className="text-5xl sm:text-6xl font-normal text-[#2D2A35] tracking-tight"
            >
              No worries.
            </motion.h1>

            <motion.p
              initial={{
                opacity: 0,
                y: 30,
              }}
              animate={{
                opacity: 1,
                y: 0,
              }}
              transition={{
                delay: 0.6,
                duration: 1.2,
                ease: [0.25, 0.1, 0.25, 1],
              }}
              className="text-xl sm:text-2xl text-[#57534E] leading-relaxed font-light"
            >
              Your progress is saved. You can return anytime to complete your
              payment.
            </motion.p>
          </div>

          {/* CTA Buttons */}
          <motion.div
            initial={{
              opacity: 0,
              y: 30,
            }}
            animate={{
              opacity: 1,
              y: 0,
            }}
            transition={{
              delay: 0.8,
              duration: 1.2,
              ease: [0.25, 0.1, 0.25, 1],
            }}
            className="w-full max-w-xs space-y-4 pt-8"
          >
            <Link to="/pricing">
              <Button fullWidth className="text-lg py-6">
                Return to payment
              </Button>
            </Link>

            <Link to="/intake">
              <button className="w-full text-[#9B87C7] hover:text-[#7D6BA8] transition-colors duration-300 text-base font-light py-3">
                Go to homepage
              </button>
            </Link>
          </motion.div>

          {/* Footer Note */}
          <motion.div
            initial={{
              opacity: 0,
            }}
            animate={{
              opacity: 1,
            }}
            transition={{
              delay: 1.0,
              duration: 1.2,
              ease: [0.25, 0.1, 0.25, 1],
            }}
            className="pt-8"
          >
            <p className="text-sm text-[#B5A8C3] font-light tracking-wide">
              We've saved your answers. Pick up right where you left off.
            </p>
          </motion.div>
        </div>
      </div>
    </div>
  )
}